<style src="./Program.css"></style>
<template>
    <div
            :style="`width:${pixelsPerMinute * program._duration}px!important`"
            ref="program" :class="[
              'epg__timeslot',
              'epg__slot-event', {
              'is-empty': program._emptySlot,
              'is-small': program._duration < 15,
              'is-before': program._isBeforeNow && !program._isLive,
              'is-live': program._isLive,
              'in-viewport': inViewport,
              'epg__timeslot--selected': program._isSelected
              }]">

        <div
                :class="['epg__slot-basic-info', {
                  // 'epg__slot-basic-info--right': !titleInViewport
                }]"
                v-on:click="selectProgram(program)" >
            <span v-if="program._duration > 4" ref="title">{{program.title}}</span>
            <div>
                <span v-if="program._duration > 4" v-html="program._start.format('H:mm')"></span>
                -
                <span v-if="program._duration > 4" v-html="program._end.format('H:mm')"></span>
            </div>
            <!--<div v-if="program._isLive" class="epg__now-line" :style="'width: '+program._nowLineOffset+'px'"> </div>-->
        </div>
        <div v-if="program._isSelected" :style="`left:${-containerPos}px; width:${timelineWidth}px`"  class="epg__slot-more-info">
            <SelectedSlot
                    :description-truncation-point="descriptionTruncationPoint"
                    :more-label="moreLabel"
                    :less-label="lessLabel"
                    :close-slot="closeSlot"
                    :set-expanded-slot-height="setExpandedSlotHeight"
                    :expanded-slot-height="expandedSlotHeight"
                    :show-program-loader="showProgramLoader"
                    :selected-program="selectedProgram" />
        </div>

    </div>
</template>

<script>
  import SelectedSlot from '../SelectedSlot/SelectedSlot.vue'

  export default {
    name: 'epg-program',
    components: {'SelectedSlot': SelectedSlot},
    props: ['timelineRect', 'horizontalDebounce', 'isGrabbed', 'program', 'pixelsPerMinute', 'selectProgram', 'containerPos', 'timelineWidth', 'showProgramLoader', 'selectedProgram', 'moreLabel', 'lessLabel', 'closeSlot', 'setExpandedSlotHeight', 'expandedSlotHeight', 'descriptionTruncationPoint'],
    data () {
      return {
        daysWidth: 0,
        daysInnerWidth: 0,
        daysTranslateProp: 0,
        daysPositions: [],
        days: [],
        inViewport: false,
        titleInViewport: true
      }
    },
    mounted () {
      requestAnimationFrame(() => {
        this.inViewport = this.isElementInViewport()
        // this.titleInViewport = this.isTitleInViewport()
      })
    },
    watch: {
      isGrabbed: function (val) {
        requestAnimationFrame(() => {
          this.inViewport = this.isElementInViewport()
          this.titleInViewport = this.isTitleInViewport()
        })
      }
    },
    methods: {
      isElementInViewport () {
        const rect = (this.$refs.program) ? this.$refs.program.getBoundingClientRect() : null
        return (
          rect.left >= -this.horizontalDebounce &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) + this.horizontalDebounce
        )
      },
      isTitleInViewport () {
        const rectTitle = (this.$refs.title) ? this.$refs.title.getBoundingClientRect() : null
        const rectProgram = (this.$refs.program) ? this.$refs.program.getBoundingClientRect() : null
        return (rectTitle && this.timelineRect) ? ((rectProgram.left + rectTitle.width + 15) >= this.timelineRect.left) : false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Program.vue?4efc15b6